export function pluralise(value: number, single: string, multi?: string): string {
    if (!multi) {
        return value === 1 ? single : `${single}s`;
    }

    return value === 1 ? single : multi;
}
